import { JSX } from 'react';
import { Alert, AlertTitle, Badge, Button, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from "react-i18next";

type Props = {
  onClick: () => void;
};

export function DuplicateAlertIntegration({ onClick }: Props): JSX.Element {
    const { t } = useTranslation('common');
  return (
    <Alert status="error" mb="4" gap={3}>
      <Badge p={1} borderRadius="full" variant="solid" colorScheme="red">
        <FontAwesomeIcon size="sm" color="white" icon={faRotateExclamation} />
      </Badge>
      <Flex flexDirection="column" alignItems="flex-start">
        <AlertTitle pb={2}>{t('common:potentialDuplicatesOnYourStudent')}</AlertTitle>

        <Text>{t('common:pleaseResolveTheDuplicatesInYour')}</Text>

        <Button variant="solid" onClick={onClick} flexShrink={0}>
          {t('common:tryAgain')}
                          </Button>
      </Flex>
    </Alert>
  );
}
